// Mapped from AmethystEvent project for better "type" safety
// Only the ones marty uses have been put here
export const MEDIA_UPLOAD_EXPERIENCE_FEEDBACK = 'MEDIA_UPLOAD_EXPERIENCE_FEEDBACK';
export const PRODUCT_REVIEW_EXPERIENCE_FEEDBACK = 'PRODUCT_REVIEW_EXPERIENCE_FEEDBACK';
export const INFLUENCER_COLLECTION_EXPERIENCE_FEEDBACK = 'INFLUENCER_COLLECTION_EXPERIENCE_FEEDBACK';
export const INFLUENCER_SHOPPABLE_PHOTO_EXPERIENCE_FEEDBACK = 'INFLUENCER_SHOPPABLE_PHOTO_EXPERIENCE_FEEDBACK';
export const INFLUENCER_SHOPPABLE_VIDEO_EXPERIENCE_FEEDBACK = 'INFLUENCER_SHOPPABLE_VIDEO_EXPERIENCE_FEEDBACK';
export const INFLUENCER_STOREFRONT_EXPERIENCE_FEEDBACK = 'INFLUENCER_STOREFRONT_EXPERIENCE_FEEDBACK';
